import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { LOCATIONS, API_PATH } from '../constants'
import { LocationFormInput } from '../types'

const updateLocation = async ({
  form,
  id,
}: {
  form: LocationFormInput
  id: number
}) => {
  await fetchAPI({
    method: 'put',
    path: `${API_PATH}/${id}`,
    data: form,
  })
}

export const useUpdateLocation = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateLocation, {
    onSuccess: async () => {
      await queryClient.refetchQueries([LOCATIONS])

      toast({
        description: t('views.admin.campaigns.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
